
/**
 * Serialize Model
 */
Backbone.Model.prototype.serializeModel = function () {
    'use strict';

    return _.clone(this.attributes);
};
